import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import OurBlogBox from '../element/OurBlogBox';
import { IMAGES } from '../layout/theme';
import { Link } from 'react-router-dom';
import api from '../services/api';

// Get API base URL from environment
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8083';

interface FeaturedPost {
    public_id: string;
    title: string;
    slug: string;
    excerpt: string;
    featured_image?: string;
    author: string;
    publish_date: string;
    category?: {
        name: string;
    };
}

const OurBlog = () => {
    const { t } = useTranslation();
    const [featuredPosts, setFeaturedPosts] = useState<FeaturedPost[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadFeaturedPosts();
    }, []);

    const loadFeaturedPosts = async () => {
        try {
            setLoading(true);
            console.log('Fetching featured posts from API...');
            const data = await api.get('/api/blog/posts/featured?limit=3');
            console.log('Response data:', data);
            if (data.success && data.data) {
                console.log('Setting featured posts:', data.data.length, 'posts');
                setFeaturedPosts(data.data);
            } else {
                console.log('No featured posts found or invalid response');
            }
        } catch (error) {
            console.error('Error loading featured posts:', error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="center-title">
                        <span className="sub-title" >{t('ourBlog.subtitle')}</span>
                        <h2 className="h2-title">{t('ourBlog.title')}</h2>
                    </div>
                </div>
            </div>
            <div className="blog-list">
                {loading ? (
                    <div className="row">
                        <div className="col-12">
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-3 text-muted">Loading featured posts...</p>
                            </div>
                        </div>
                    </div>
                ) : featuredPosts.length > 0 ? (
                    <>
                        <div className="row">
                            {featuredPosts.map((post, ind)=>(
                                <div className="col-lg-4" key={post.public_id || ind}>
                                    <OurBlogBox
                                        image={post.featured_image ? `${API_BASE_URL}${post.featured_image}` : IMAGES.BlogImg1}
                                        title={post.title}
                                        excerpt={post.excerpt}
                                        slug={post.slug}
                                        author={post.author}
                                        publishDate={post.publish_date}
                                        category={post.category?.name}
                                    />
                                </div>
                            ))}
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="view-all">
                                    <Link to={"/blog-list"} className="sec-btn"><span>{t('ourBlog.viewAllNews')}</span></Link>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="row">
                        <div className="col-12">
                            <div className="text-center py-5">
                                <p className="text-muted">No featured posts available. Pin some posts from the CMS to display them here.</p>
                                <Link to={"/cms/blog"} className="sec-btn mt-3"><span>Go to Blog CMS</span></Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OurBlog;